import { useState, useEffect } from "react";
import IdNameModel from "../../../models/common/IdNameModel";
import { Controller, useForm } from "react-hook-form";
import masterDataService from '../../../services/master-data-service';
import toasterUtils from "../../../utils/toaster-utils";
import ScheduleInterviewRequest from "../../../models/candidate/request/ScheduleInterviewRequest";
import CandidateService from '../../../services/candidate/candidate-service';
import { InterviewTypeEnum } from "../../../models/enums/InterviewTypeEnum";
import modalUtils from "../../../utils/modal-utils";
import { useHistory } from "react-router";
import { FORM_SELECT_RULE } from "../../../utils/validation-utils";
import { Select, MenuItem, Button, FormControl, InputLabel, FormHelperText, FormControlLabel, Checkbox, Autocomplete, TextField } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import CcAvenueRedirect from "./CcAvenueRedirect";
import AppConfig from "../../../config";
import dateTimeUtils from "../../../utils/date-utils";

interface ScheduleInterviewProps {
    primarySkillsList: IdNameModel[];
    timeSlotsList: IdNameModel[];
    candidateId: string;
};

type RedirectProps = {
    tid?: string;
    merchant_id?: string;   // optional; you can omit and let server use config
    order_id: string;
    amount: string;         // keep as string "1500.00"
    currency: string;
    redirect_url: string;
    cancel_url: string;
    language?: string;

    billing_name?: string;
    billing_address?: string;
    billing_city?: string;
    billing_state?: string;
    billing_zip?: string;
    billing_country?: string;
    billing_tel?: string;
    billing_email?: string;

    delivery_name?: string;
    delivery_address?: string;
    delivery_city?: string;
    delivery_state?: string;
    delivery_zip?: string;
    delivery_country?: string;
    delivery_tel?: string;

    promo_code?: string;
    customer_identifier?: string;

    merchant_param1?: string;
    merchant_param2?: string;
    merchant_param3?: string;
    merchant_param4?: string;
    merchant_param5?: string;
};

const ScheduleInterviewComponent = (props: ScheduleInterviewProps) => {
    const history = useHistory();
    const [secondarySkillList, setSecondarySkillList] = useState<IdNameModel[]>([]);
    const [secondarySkills, setSecondarySkills] = useState<number[]>([0, 0, 0, 0, 0]);
    const [redirectProps, setRedirectProps] = useState<RedirectProps | null>(null);

    const {
        register,
        handleSubmit,
        control,
        formState: { errors, isValid },
    } = useForm<ScheduleInterviewRequest>({
        mode: "onChange"
    });

    useEffect(() => {
    }, [])

    const getSecondarySkills = (primarySkillId: string | number) => {
        modalUtils.showLoader();
        masterDataService.loadSecondarySkills(Number(primarySkillId)).then((res) => {
            modalUtils.closeModal();
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setSecondarySkillList(res.items);
        }).catch((error) => {
            modalUtils.closeModal();
            toasterUtils.showError("Erorr fetching Primary skills");
        });
    };

    const onSubmit = (formData: ScheduleInterviewRequest) => {
        if (!isValid) {
            toasterUtils.showError("Please fill all mandatory fields");
            return;
        }
        if (formData.interviewDate === null) {
            toasterUtils.showError("Interview date is mandatory");
            return;
        }
        const checkMandatorySecondarySkills = (formData.secondarySkills ?? []).slice(0, 3);
        if (checkMandatorySecondarySkills.some(v => v === 0 || v === null || v === undefined)) {
            toasterUtils.showError("Secondary skills are mandatory");
            return;
        }
        const skillsDuplicateArr = (formData.secondarySkills ?? []).filter(
            (id, idx) => !(idx > 3 && (id === 0 || id == null))
        );
        //var skillsDuplicateArr = cleanedSkills.map(function (item) { return item });
        var isDuplicate = skillsDuplicateArr.some(function (item, idx) {
            return skillsDuplicateArr.indexOf(item) != idx
        });
        if (isDuplicate) {
            toasterUtils.showError("Secondary skills should be unique.");
            return;
        } else {
            formData.candidateId = props.candidateId;
            formData.interviewDateString = dateTimeUtils.getFormattedDate(formData.interviewDate);
            formData.interviewDate = dateTimeUtils.addDays(formData.interviewDate, 1);
            formData.interviewTypeId = InterviewTypeEnum.Video;
            formData.secondarySkills = formData.secondarySkills.filter(n => n !== 0);
            modalUtils.showLoader();
            CandidateService.scheduleInterview(formData).then((res) => {
                modalUtils.closeModal();
                if (!res.isSuccess || res.errorMessages.length > 0) {
                    toasterUtils.showError(res.errorMessages.toString());
                    return;
                }
                toasterUtils.showSuccess(res.informationMessages.toString());
                setTimeout(() => {
                    history.push("/candidate-dashboard");
                }, 1000);
            }).catch((error) => {
                modalUtils.closeModal();
                toasterUtils.showError(error);
            });
        }
    };

    const paymentGateway = () => {
        setRedirectProps({
            tid: "",
            merchant_id: "",   // optional; you can omit and let server use config
            order_id: `ORD-${Date.now()}`,
            amount: "10.0",      // keep as string "1500.00"
            currency: "INR",
            redirect_url: `${AppConfig.apiBaseUrl}/${AppConfig.candidate.ccavResponseURL}`,
            cancel_url: `${AppConfig.apiBaseUrl}/${AppConfig.candidate.ccavResponseURL}`,
            language: "Eng",
            billing_name: "Praneeth",
            billing_address: "Paymenttowardsiaminterviewed.com",
            billing_city: "Bangalore",
            billing_state: "Karnataka",
            billing_zip: "560043",
            billing_country: "India",
            billing_tel: "9886146841",
            billing_email: "praneeth.pn@gmail.com",
            delivery_name: "IAmInterviewed",
            delivery_address: "Paymenttowardsiaminterviewed.com",
            delivery_city: "Bangalore",
            delivery_state: "Karnataka",
            delivery_zip: "560043",
            delivery_country: "India",
            delivery_tel: "8050065578",
            promo_code: "",
            customer_identifier: "",
            merchant_param1: "additionalInfo.",
            merchant_param2: "additionalInfo.",
            merchant_param3: "additionalInfo.",
            merchant_param4: "additionalInfo.",
            merchant_param5: "additionalInfo."
        });
    };

    return (
        <div className="card card-white">
            <div className="card-body">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="row">
                        <div className="col-md-4">
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <Controller name="interviewDate" control={control} rules={{ required: "Date is required" }}
                                    render={({ field, fieldState }) => (
                                        <FormControl fullWidth margin="normal" error={!!fieldState.error}>
                                            <DatePicker
                                                label="Interview Date"
                                                value={field.value}
                                                onChange={field.onChange}
                                                format="YYYY-MMM-DD"
                                                minDate={dayjs()}
                                                slotProps={{
                                                    textField: {
                                                        size: "small",
                                                        fullWidth: true,
                                                        error: !!fieldState.error,
                                                        helperText: fieldState.error?.message,
                                                        onKeyDown: (e) => e.preventDefault(),
                                                    },
                                                }}
                                            />
                                        </FormControl>
                                    )}
                                />
                            </LocalizationProvider>
                        </div>
                        <div className="col-md-4">
                            <Controller name="timeSlotId" control={control} defaultValue={0} rules={FORM_SELECT_RULE}
                                render={({ field }) => (
                                    <Autocomplete {...field} value={props.timeSlotsList.find(x => x.id === field.value) || null}
                                        onChange={(_, newValue) => field.onChange(newValue ? newValue.id : 0)} options={props.timeSlotsList} getOptionLabel={(option) => option.name || ""}
                                        renderInput={(params) => (
                                            <TextField {...params} label="Time Slot" size="small" required margin="normal" fullWidth error={!!errors.timeSlotId} helperText={errors.timeSlotId?.message} />
                                        )}
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                    />
                                )}
                            />
                        </div>
                        <div className="col-md-4">
                            <Controller name="primarySkillId" control={control} defaultValue={0} rules={FORM_SELECT_RULE}
                                render={({ field }) => (
                                    <Autocomplete {...field} value={props.primarySkillsList.find(x => x.id === field.value) || null}
                                        onChange={(_, newValue) => { const id = newValue?.id ?? 0; field.onChange(id); getSecondarySkills(id); }} options={props.primarySkillsList} getOptionLabel={(option) => option.name || ""}
                                        renderInput={(params) => (
                                            <TextField {...params} label="Primary Skill" size="small" required margin="normal" fullWidth error={!!errors.primarySkillId} helperText={errors.primarySkillId?.message} />
                                        )}
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                    />
                                )}
                            />
                        </div>
                    </div>
                    {secondarySkills.map((field, index) => (
                        <div className="row" key={index}>
                            <div className="col-md-2">
                                <label className="form-label">
                                    Secondary Skill {index + 1}: {index < 3 && <span className="required">*</span>}
                                </label>
                            </div>
                            <div className="col-md-6">
                                <Controller name={`secondarySkills.${index}`} control={control} defaultValue={0} rules={index < 3 ? FORM_SELECT_RULE : undefined}
                                    render={({ field, fieldState }) => (
                                        <Autocomplete value={secondarySkillList.find(x => x.id === field.value) || null}
                                            onChange={(_, newValue) => field.onChange(newValue ? newValue.id : 0)} options={secondarySkillList} getOptionLabel={(option) => option.name || ""}
                                            renderInput={(params) => (
                                                <TextField {...params} label="Secondary Skill" size="small" required={index < 3} margin="normal" fullWidth error={!!fieldState.error} helperText={fieldState.error?.message ?? ""} />
                                            )}
                                            isOptionEqualToValue={(option, value) => option.id === value.id}
                                        />
                                    )}
                                />
                            </div>
                        </div>
                    ))}
                    <div className="row">
                        <div className="col-md-6">
                            <FormControl fullWidth margin="normal" error={!!errors.termsAndConditions}>
                                <FormControlLabel
                                    control={
                                        <Checkbox {...register("termsAndConditions", { required: true })} color="primary" size="small" />
                                    }
                                    label={
                                        <span>
                                            I Agree for Terms and Conditions <span className="required">*</span>
                                        </span>
                                    }
                                />
                                {errors.termsAndConditions && (
                                    <FormHelperText error>
                                        You must agree to the terms and conditions.
                                    </FormHelperText>
                                )}
                            </FormControl>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-9"></div>
                        <div className="col-md-3">
                            <Button variant="contained" color="primary" type="submit" disabled={!isValid}>
                                Schedule Interview
                            </Button>

                            <Button variant="contained" color="primary" type="button" onClick={paymentGateway} sx={{ display: 'none' }}>
                                Pay 10
                            </Button>
                            {redirectProps && <CcAvenueRedirect {...redirectProps} />}
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};
export default ScheduleInterviewComponent;